import React, { useEffect, useState } from 'react';
import { X, Link, Search } from 'lucide-react';

const AssignAdvisorModal = ({
  onClose,
  onSubmit,
  formData,
  setFormData,
  groups,
  advisors,
  loadingAdvisors,
  actionLoading,
  fetchAdvisors
}) => {
  const [advisorSearch, setAdvisorSearch] = useState('');

  useEffect(() => {
    fetchAdvisors();
  }, [fetchAdvisors]);

  const filteredAdvisors = advisors.filter(a =>
    (a.role === 'advisor' || a.role === 'admin' || a.role === 'investment banker') &&
    (a.username?.toLowerCase().includes(advisorSearch.toLowerCase()) ||
      a.name?.toLowerCase().includes(advisorSearch.toLowerCase()))
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div className="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Assign Advisor to Pool</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Select Pool</label>
            <select
              value={formData.group_id}
              onChange={(e) => setFormData({ ...formData, group_id: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
              required
            >
              <option value="">Select a pool</option>
              {groups.map(group => (
                <option key={group.id} value={group.id}>{group.group_name}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Select Advisor</label>
            {loadingAdvisors ? (
              <div className="flex justify-center py-4">
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
              </div>
            ) : (
              <>
                <div className="relative mb-2">
                  <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Search by username..."
                    value={advisorSearch}
                    onChange={(e) => setAdvisorSearch(e.target.value)}
                    className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                  />
                </div>
                <select
                  value={formData.advisor_id}
                  onChange={(e) => setFormData({ ...formData, advisor_id: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  required
                  size={Math.min(filteredAdvisors.length + 1, 6)}
                >
                  <option value="">Select an advisor</option>
                  {filteredAdvisors.map((advisor, index) => (
                    <option key={`advisor-${advisor.id}-${index}`} value={advisor.id}>
                      {advisor.username}{advisor.name ? ` — ${advisor.name}` : ''}{advisor.role ? ` (${advisor.role})` : ''}
                    </option>
                  ))}
                </select>
              </>
            )}
          </div>

          <div className="flex gap-3 mt-6">
            <button
              type="submit"
              disabled={actionLoading || !formData.group_id || !formData.advisor_id}
              className="flex-1 bg-primary hover:bg-primaryDark disabled:bg-gray-400 text-white px-4 py-2 rounded-lg font-medium flex items-center justify-center gap-2 transition-colors"
            >
              {actionLoading ? (
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              ) : (
                <Link className="w-4 h-4" />
              )}
              Assign Advisor
            </button>
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AssignAdvisorModal;
